import { render, staticRenderFns } from "./FeesDesiresRules.vue?vue&type=template&id=33390fae"
import script from "./FeesDesiresRules.vue?vue&type=script&lang=js"
export * from "./FeesDesiresRules.vue?vue&type=script&lang=js"
import style0 from "./FeesDesiresRules.vue?vue&type=style&index=0&id=33390fae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports